export default {
    contact: 'Contact',
    references: 'References',
    language: 'Language',
    termsOfUse: 'Terms of Use',
    privacy: 'Privacy Policy',
    references: 'References',
    login: 'Log in',
    logout: 'Log out',
    resetPassword: 'Reset password',
    darkMode: 'Dark Mode',
    back: 'Back',
    subscribe: 'Subscribe',
    emailAddress: 'Email address',
    joinOurMailList: 'Sign up to learn more',
    youAreAllSetFeedback: 'Hurray! You\'re all set!',
    SendingInfoFeedback: 'Sending information...',
    mailingListFeatures: 'Get the latest on our photography and digital art resources and tutorials.',
    titleOfYourEntry: 'Title of Your Entry',
    IntroOfYourEntry: 'Intro of your entry',
    prologue: 'Prologue',
    live: 'Live',
    drafts: 'Drafts',
    draft: 'Draft',
    newEntry: 'New Entry',
    createNewEntry: 'Create New Entry',
    createNewPost: 'Create New Post',
    fileSizeLimit: 'Max filesize',
    chooseFile: 'Choose File',
    recommendedResolution: 'Recommended resolution',
    deleteImage: 'Delete image',
    published: 'Published',
    upload: 'Upload',
    story: 'Story',
    update: 'Update',
    cancel: 'Cancel',
    iEatCookies: 'I eat cookies so I don\'t get hungry',
    readMore: 'Read more',
    okey: 'Okey!',
    deleteEntryQuestion: 'Delete Entry?',
    thinkTwice: 'Think twice! This action cannot be undone.',
    delete: 'Delete',
    uploadTime: 'Upload time',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    viewEntry: 'View Entry',
    storywriter: 'Writer',
    updated: 'Updated',
    contactUs: 'Contact us',
    weAreHereToHelp: 'We\'re always here to help you!',
    businessInquiries: 'Business inquiries',
    businessSolutions: 'Business offers, Collaborations, Advertisements',
    supportInquiries: 'Support inquiries',
    supportSolutions: 'Bug reporting, Feature requests, Platform issues',
    supportTeam: 'Support team',
    street: 'street',
    hungary: 'Hungary',
    getThisBundle: 'Get This Bundle',
    entryUpdateSuccess: 'Entry was successfully updated.',
    entryUpdateError: 'Entry couldn\'t be updated. Something went wrong on our end :(',
    entryDeleteSuccess: 'Entry successfully deleted.',
    entryDeleteError: 'Failed to delete entry. Something went wrong on our end :(',
    entryUploadSuccess: 'Entry successfully uploaded.',
    entryUploadError: 'Couldn\'t upload entry. Something went wrong on our end :(',
    coverUpdateSuccess: 'Cover successfully updated.',
    coverUpdateError: 'Couldn\'t update cover. Something went wrong on our end :(',
    profileUpdateSuccess: 'Profile successfully updated.',
    profileUpdateError: 'Couldn\'t update profile. Something went wrong on our end :(',
    keepFilesUnderLimit: 'We must keep images under 0.4 MB for performance reasons.',
    english: 'English',
    hungarian: 'Hungarian',
    notTranslatedToHungarian: 'This entry is not translated to Hungarian yet.',
    publishedBy: 'Published by',
    author: 'Author',
    comments: 'Comments',
    share: 'share',
    newPost: 'New Post',
    createdBy: 'Created by',
    storyBy: 'Story by',
    lowFrequencyOfMatter: 'The frequency of concentrated matter is really low here.',
    changesApplyInstantly: 'Changes apply instantly',
    sendPasswordResetEmail: 'Send password reset email',
    forgotPassword: 'Forgot password',
    language: 'Language Preference',
    preferredLanguageAndCurrency: 'Preferred language',
    timelinePreference: 'Timeline Preference',
    preferredEntryOrder: 'Preferred entry order',
    appearanceAndDisplay: 'Appearance and Display',
    preferredAppearance: 'Preferred appearance settings',
    securityAndPassword: 'Security and Password',
    closedBetaDisclaimer: 'Registration is currently invite-only',
    photos: 'photos',
    whatIsTheJournal: 'What is Creatillo?',
    learnAboutTheInitiative: 'Learn more about the initiative',
    downloadReferences: 'Free photo resources',
    recentlyPublished: 'Recently Published',
    newCover: 'New cover',
    joinUsOnDiscord: 'Join on Discord',
    discordPerks: 'Take part in our community',
    name: 'Name',
    editProfile: 'Edit Profile',
    intro: 'Intro',
    instagram: 'Instagram',
    website: 'Website',
    uploadCover: 'Upload Cover',
    editCover: 'Edit Cover',
    deleteCover: 'Delete Cover',
    uploadAvatar: 'Upload Avatar',
    deleteAvatar: 'Delete Avatar',
    entries: 'Entries',
    entry: 'Entry',
    posts: 'Posts',
    post: 'Post',
    relatedEntry: 'Related Journal Entry',
    relatedPost: 'Related Blog Post',
    recrop: 'reCrop',
    orientation: 'Orientation',
    landscape: 'Landscape',
    donateThroughPayPal: 'Donate through PayPal',
    likeThisTool: 'Like this tool? Donate!',
    reCropDescription1: 'I\'ve created the reCrop tool to save myself from the daunting job of cropping, saving and uploading the optimized images to cloud. The time I invested in creating this tool would be enough to crop, save and upload like a thousand photos.',
    reCropDescription2: 'Make me feel better by tossing some coins at me. Seriously.',
    recropForInstagram: 'reCrop by Creatillo',
    recropDescription: 'Crop your horizontal photos into vertical carousels with reCrop',
    cropImagesEasily: 'Cropping made easy',
    under3mb: 'File size must be under 3 MB.',
    alreadyPortrait: 'Image orientation is already portrait.',
    blurBackground: 'Blur background',
    notSupportedInSafari: 'Currently not supported in Safari',
    whyRecrop: 'Why reCrop?',
    title: 'Title',
    subtitle: 'Subtitle',
    summary: 'Summary',
    slugError: 'The slug can only contain letters, numbers and hyphens.',
    writeYourPostInNextStep: 'You\'ll write your post in the next step',
    historicalTime: 'Historical Time',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    order: 'Order',
    chronology: 'Chronology',
    newerToOlder: 'From newer to older',
    olderToNewer: 'From older to newer',
    learnMoreAbout: 'Learn more about',
    howWeHandleData: 'how we handle data',
    and: 'and',
    whatTermsAreApplied: 'what terms are applied',
    whenUsingTheSite: 'to you when using Creatillo.',
    generalSettings: 'General Settings',
    languageCurrencyAppearanceMore: 'Language, Appearance & More',
    settings: 'Settings',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    copiedToClipBoard: 'Successfully copied to clipboard! 🌟',
    actionError: 'Ran into an unexpected error 😔',
    confirmPageLeave: 'You have unsaved changes on the page. Are you sure you want to leave?',
    updatedLanguagePreference: 'We have successfully updated your language preferences 🤩',
    meetCreatillo: 'Meet Creatillo',
    menu: 'Menu',
    reply: 'Reply',
    send: 'Send',
    deleteCommentDialog: 'Do you wish to delete your comment?',
    deleteWithAllReplies: 'This action will result in deleting all replies too.',
    toJoinTheConversation: 'to join the conversation!',
    toStartaConversation: 'to start a conversation!',
    loginPrompt: 'Log in',
    loginWithGoogle: 'Log in with Google',
    orUseEmail: 'Or use your email',
    noCommentsYet: 'No comments yet.',
    passwordResetSent: 'We\'we sent you the email to reset your password.',
    commentSuccessfullyDeleted: 'Comment successfully deleted.',
    provideEmail: 'Please provide your email address.',
    nobodyHearsYou: 'Nobody hears you',
    returnToThe: 'Return to the',
    homepage: 'Home page',
    verifyYourEmail: 'Verify your email for increased security.',
    sendVerification: 'Send verification',
    createAccount: 'Create account',
    createAccountPrompt: 'Create your account and get involved in shaping the future of our platform. If you\'re unsure, join our Discord and meet us first!',
    newHere: 'New here?',
    alreadyMember: 'Already a member?',
    invalidCredentials: 'This account either doesn\'t exist or your credentials are wrong.',
    invalidUsername: 'Please set a valid username.',
    invalidCredentialFormat: 'Please double-check the format of your email and password.',
    username: 'Username',
    password: 'Password',
    yourProfileUrl: 'Your profile URL will be',
    usernameIsTaken: 'The choosen username is already in use by someone. Please choose another one!',
    inventoryTitle: 'Inventory',
    inventorySubtitle: 'Access your collections in one place',
    contains: 'Contains',
    images: 'Images',
    download: 'Download',
    learnMore: 'Learn more',
    selectImages: 'Select images',
    publishEntry: 'Publish entry',
    entryURL: 'Entry URL',
    featuredEntry: 'Featured Entry',
    slugIsTaken: 'Slug is already in use. Please choose a different one.',
    slugIsTooShort: 'The slug should be at least 5 characters long.',
    imageError: 'Please add at least one image.',
    url: 'URL',
    fresh: 'Fresh',
    recentlyFeatured: 'Recently Featured',
    featured: 'Featured',
    entryCardPreview: 'Entry Card Preview',
    advancedOptions: 'Advanced options',
    slugDescription: 'Adding a custom URL will help search engines discover and better understand your entry. If not set, a random ID will be generated for your entry.',
    historicalTimeDescription: 'People may browse your feed based on historical event order. If not set, people will always see your entries in upload order.',
    moreFrom: 'More from',
    furtherWorks: 'Further works',
    writeAComment: 'Write a comment',
    entryImageLimitReached: 'You can only select up to 8 images for carousel entries.',
    adEngine: {
        adBy: 'Ad by',
        register: {
            text: 'Don\'t let this mission start without <i>you</i>',
            cta:  'Get on board!'
        }
    },
    cookieBar: {
        heading: 'Allow the use of cookies from Creatillo on this browser?',
        p1: 'We use cookies to enhance your browsing experience and to gain insights about the people using Creatillo through analytics data.',
        p2: 'You can allow the use of all cookies or just essential cookies below. You can learn more about cookies and how we use them in our',
        allowEssential: 'Allow essential only',
        allowAll: 'Allow essential and optional'
    },
    follow: 'Follow',
    follower: 'Follower',
    followers: 'Followers',
    following: 'Following',
    notifications: 'Notifications',
    noNotifications: 'You don\'t have any notifications yet.',
    newEntryPublished: 'published a new entry',
    newEntryComment: 'commented on your entry',
    newBlogComment: 'commented on your post',
    repliedOn: 'replied on',
    startedFollowingYou: 'started following you',
    signUp: 'Sign up',
    commentAs: 'Comment as',
    closedRegistration: 'Join the waitlist and follow us on our Discord to know when we go public.',
    entryDoesntExist: 'The entry you\'re looking for doesn\'t exist.',
    entryDeletedOrBroken: 'It has been probably deleted, or you\'ve encountered a broken link.',
    creatorDoesntExist: 'The creator you\'re looking for doesn\'t exist.',
    creatorDeletedOrBroken: 'The profile has been probably deleted, or you\'ve encountered a broken link.',
    nothingHereYet: 'Nothing here yet.',
    startFollowingCreators: 'Start following your favorite creators!',
    terms: {
        readAndAgreed: 'I\'ve read and agreed to the',
        termsOfCreatillo: 'Terms of Creatillo',
        readAndUnderstood: 'I\'ve read and understood how the site uses and shares data and handles cookies in the',
    },
    likedYourEntry: 'liked your entry',
    read: 'Read',
    comment: 'comment',
    allThe: 'All the',
    toComment: 'to comment',
    you: 'you',
    likedBy: 'Liked by',
    likedByYou: 'Liked by',
    other: 'other',
    others: 'others',
    beTheFirstToLike: 'Be the first to like',
    loadMore: 'Load more',
    close: 'Close',
    followedBy: 'Followed by',
    followersOf: 'Followers of',
    featuredYourEntry: 'featured your entry',
    recentlyFollowed: 'Recently followed',
    searchCreators: 'Search creators'
}